import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/inspectionRecord',
    meta: { title: '巡查记录' },
    component: Layout,
    redirect: '/inspectionRecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '巡查记录', activeMenu: '/inspectionRecord' },
        component: () => import('@/views/inspectionRecord/InspectionRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '巡查记录详情', activeMenu: '/inspectionRecord' },
        component: () => import('@/views/inspectionRecord/InspectionRecordDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增巡查记录', activeMenu: '/inspectionRecord' },
        component: () => import('@/views/inspectionRecord/InspectionRecordAdd.vue')
      }
      // {
      //   path: 'edit',
      //   meta: { title: '编辑巡查记录', activeMenu: '/inspectionRecord' },
      //   component: () => import('@/views/inspectionRecord/InspectionRecordAdd.vue')
      // }

    ]
  }, {
    path: '/inspectionRecordStatistics',
    meta: { title: '巡查记录统计' },
    component: Layout,
    redirect: '/inspectionRecordStatistics/list',
    children: [
      {
        path: 'list',
        meta: { title: '巡查记录统计', activeMenu: '/inspectionRecordStatistics' },
        component: () => import('@/views/inspectionRecordStatistics/InspectionRecordStatistics.vue')
      }]
  }

]
